// dashboard shortcuts
import { Link } from "react-router-dom";
import IconLabel from "../webb/icon-label";

import WebbDividerSmall from "../webb/webb-divider-sm";

import { UserForm } from "../../services/srvc-utilities";
import { GetLocalUser, GetLocalBusiness } from "../../services/srvc-auth-user";

const list = require("../../data/data-user-tasks.json").data;

export default function UserTasksModule() {

  const asset = UserForm() === "in" ? GetLocalUser() : GetLocalBusiness();
  const data = (list.filter(item => item.user.includes(asset.form)));

  return (
  <>
    <WebbDividerSmall />
    <div className="row row-cols-3 row-cols-md-3 g-1">

      {data && data.map((item, i) => ( item.actv ?
        <div className="col text-center" key={i}>
          <Link to={`/${UserForm()}/${item.link}`}>
            <IconLabel 
              actv={item.actv}
              icon={item.icon}
              name={item.name}
            />            
            
          </Link>
        </div>
      :''))}

    </div>
    <WebbDividerSmall />
  </>
  )
}